import {Component, OnDestroy, OnInit} from '@angular/core';
import * as actionsUi from './qs-checks-controlling-home.actions.ui';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {UuidService} from '@orga-app/providers/uuid.service';
import {PageState} from './qs-checks-controlling-home.reducer';
import * as fromMandantModule from '@orga-app/mandant/reducer';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings} from '@orga-app/settings/settings.model';
import {AlertController, LoadingController, ModalController, NavController, Platform, ViewWillEnter} from '@ionic/angular';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';
import {FunktionsbereichRolle, Pruefobjekt, SaisonUebersicht, SaisonUebersichtRequest, VeranstaltungMinimal, VeranstaltungUebersichtRequest} from '../../../../clients/qschecks';
import {
    getAktuelleVeranstaltung,
    getSaisonUebersicht, getSaisonUebersichtFehler, getSaisonUebersichtLaden
} from './qs-checks-controlling-home.selectors';
import {
    AktuelleVeranstaltungQsControllingSetzenAction, SaisonUebersichtLadenAction
} from './qs-checks-controlling-home.actions.ui';
import {Subject} from 'rxjs';
import {QschecksControllingSaisonFilterPage} from '../qschecks-controlling-saison-filter/qschecks-controlling-saison-filter.page';
import {Router} from '@angular/router';
import {takeWhile} from 'rxjs/operators';
import {DocumentService} from '@orga-app/providers/document.service';
import {NotificationService} from '@orga-app/providers/notification.service';


@Component({
    selector: 'page-qs-checks-controlling-home',
    templateUrl: 'qs-checks-controlling-home.page.html',
    styleUrls: ['./qs-checks-controlling-home.page.scss'],
})

export class QsChecksControllingHomePage implements OnInit, OnDestroy, ViewWillEnter {
    public saisonUebersicht$: Observable<SaisonUebersicht>;
    public saisonUebersichtLaden$: Observable<boolean>;
    public saisonUebersichtFehler$: Observable<boolean>;

    public aktuelleVeranstaltung$: Observable<VeranstaltungMinimal>;

    // VARIABLEN ZUR ZWISCHENSPEICHERUNG
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    private aiName = 'QsChecksControllingHomePage';

    private unsubscribe$ = new Subject();

    public alive = true;

    constructor(public navCtrl: NavController,
                public modalCtrl: ModalController,
                private router: Router,
                private storeMandant: Store<fromMandantModule.MandantState>,
                public platform: Platform,
                private uuid: UuidService,
                private store: Store<PageState>,
                public settingsProvider: SettingsProvider,
                public loadingCtrl: LoadingController,
                private documentService: DocumentService,
                private notificationService: NotificationService,
                public alertCtrl: AlertController
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
    }

    ngOnInit() {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        this.saisonUebersicht$ = this.store.pipe(select(getSaisonUebersicht));
        this.saisonUebersichtLaden$ = this.store.pipe(select(getSaisonUebersichtLaden));
        this.saisonUebersichtFehler$ = this.store.pipe(select(getSaisonUebersichtFehler));

        this.aktuelleVeranstaltung$ = this.store.pipe(select(getAktuelleVeranstaltung));
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
        this.store.dispatch(new actionsUi.SaisonUebersichtNeuLadenAction());
    }


    async veranstaltungDetails(veranstaltung: VeranstaltungMinimal) {
        this.store.dispatch(new AktuelleVeranstaltungQsControllingSetzenAction(veranstaltung));
        await this.router.navigate(['/qschecks-controlling/veranstaltung']);
    }

    async oeffneFilterPage() {
        const params = {
        };
        // console.log('Params: ', params);
        const modal = await this.modalCtrl.create({component: QschecksControllingSaisonFilterPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                // console.log('REsult: ', result);
                this.store.dispatch(new SaisonUebersichtLadenAction(result.data));
            }
        });

        await modal.present();
    }

    async downloadExcelSaisonUebersicht(saisonUebersicht: SaisonUebersicht) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Exceldownload für Saisonübersicht wird geladen'
        });
        await loading.present();

        const url = '/api/qschecks/query/controlling/saison/uebersicht/excel';
        const request: SaisonUebersichtRequest = {
            saison_id_liste: saisonUebersicht.saison2.saison_id_liste,
            pruefer_rolle_ids: saisonUebersicht.pruefer_rolle_liste.map(x => x.rolle.rolle_id),
            pruefplan_id: saisonUebersicht.pruefplan.pruefplan_id,
        };
        this.documentService.getDocumentByPost(url, request).pipe(takeWhile(() => this.alive))
            .subscribe(async (document) => {
                    if (document != null) {
                        // console.log('loaded');
                        await loading.dismiss();

                        const date = new Date();
                        const month: number = <number>date.getMonth() + 1;
                        this.documentService.saveFile(document, 'saisonUebersicht-' + date.getFullYear() + '-' + month + '-' + date.getDate() + '.xlsx');
                    }
                },
                error => {
                    this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                    loading.dismiss();
                }, () => {
                });
    }

    async spieltagsauswertungNachPrueferRolleExcelOeffnen(veranstaltung: VeranstaltungMinimal, rolle: FunktionsbereichRolle, saisonUebersicht: SaisonUebersicht) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Exceldownload für Spieltagsauswertung nach Rolle wird geladen'
        });
        await loading.present();

        const url = '/api/qschecks/query/controlling/veranstaltung/excel';
        const request: VeranstaltungUebersichtRequest = {
            veranstaltung_id: veranstaltung.veranstaltung_id,
            pruefer_rolle_ids: [rolle.rolle.rolle_id],
            pruefplan_id: saisonUebersicht.pruefplan.pruefplan_id,
        };
        this.documentService.getDocumentByPost(url, request).pipe(takeWhile(() => this.alive))
            .subscribe(async (document) => {
                    if (document != null) {
                        // console.log('loaded');
                        await loading.dismiss();

                        const date = new Date();
                        const month: number = <number>date.getMonth() + 1;
                        const filename = 'spieltagsauswertung-' + veranstaltung.titel.split('.').join('') + '-' + rolle.rolle.rolle_id + '-' + date.getFullYear() + '-' + month + '-' + date.getDate();
                        this.documentService.saveFile(document, filename + '.xlsx');
                    }
                },
                error => {
                    this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                    loading.dismiss();
                }, () => {
                });
    }

    async spieltagsauswertungExcelOeffnen(veranstaltung: VeranstaltungMinimal, saisonUebersicht: SaisonUebersicht) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Exceldownload für Spieltagsauswertung wird geladen'
        });
        await loading.present();

        const url = '/api/qschecks/query/controlling/veranstaltung/excel';
        const request: VeranstaltungUebersichtRequest = {
            veranstaltung_id: veranstaltung.veranstaltung_id,
            pruefer_rolle_ids: saisonUebersicht.pruefer_rolle_liste.map(x => x.rolle.rolle_id),
            pruefplan_id: saisonUebersicht.pruefplan.pruefplan_id,
        };
        this.documentService.getDocumentByPost(url, request).pipe(takeWhile(() => this.alive))
            .subscribe(async (document) => {
                    if (document != null) {
                        // console.log('loaded');
                        await loading.dismiss();

                        const date = new Date();
                        const month: number = <number>date.getMonth() + 1;
                        const filename = 'spieltagsauswertung-' + veranstaltung.titel.split('.').join('') + '-' + date.getFullYear() + '-' + month + '-' + date.getDate();
                        this.documentService.saveFile(document, filename + '.xlsx' );
                    }
                },
                error => {
                    this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                    loading.dismiss();
                }, () => {
                });
    }

    trackByVeranstaltungen(index: number, veranstaltungMinimal: VeranstaltungMinimal) {
        return veranstaltungMinimal.veranstaltung_id;
    }

    trackByFBRollen(index: number, fbRolle: FunktionsbereichRolle) {
        return fbRolle.funktionsbereich.funktionsbereich_id + fbRolle.rolle.rolle_id;
    }

    trackByErgebnisse(index: number, pruefobjekt: Pruefobjekt) {
        return pruefobjekt.pruefobjekt_id;
    }

}
